import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetAdvertiseList = () => {
    const [fetchResult, fetchRequest, isLoading] = useFetch()
    const [searchParams] = useSearchParams()
    const page = searchParams.get("page")

    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/admin/advertise/list?page=${page}`)
    }, [page])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "page") setAlert("페이지 번호를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [fetchResult, isLoading]
}

export default useGetAdvertiseList